import AppBar from '@/components/page/appBar'
import Footer from '@/components/page/footer'
import PromotionModal from '@/components/promotion/PromotionModal'
import React, { FunctionComponent } from 'react'
import Mascot from '@/components/promotion/Mascot'

interface Prop {
  token?: string
}
const MainLayout: FunctionComponent<React.PropsWithChildren<Prop>> = (props) => {
  return (
    <div className='bg-surfaceLow'>
      <AppBar />
      <Mascot />
      <PromotionModal />
      <div className='pt-28'>
        {props.children}
      </div>
      <Footer />
    </div>

  )
}

export default MainLayout
